<template>
  <div class="sendpaper-mask">
    <div class="sendpaper-wrapper">
      <div class="sendpaper-container">
        <p class="sendpaper-header">Email Address</p>

        <span>email : </span><input v-model="user_email" type="text" />
        <!--sendnewspaper @click="$emit('pdfservercall')"-->
        <button class="sendpaper-button" @click="$emit('pdfservercall')">
          Send
        </button>
        <button class="sendpaper-button" @click="$emit('closepapermodal')">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  computed: {
    user_email: {
      get() {
        return this.$store.state.user_email;
      },
      set(value) {
        console.log(value);
        this.$store.commit("SetUseremail", value);
      },
    },
  },
};
</script>

<style>
.sendpaper-mask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.sendpaper-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.sendpaper-container {
  width: 270px;
  margin: 0px auto;
  padding: 20px 30px;
  border: black solid 5px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.sendpaper-header {
  background-color: black;
  color: white;
  text-align: center;
  font-size: 1em;
  padding: 2%;
}
.sendpaper-container input {
  font-size: 1em;
  margin: 1em 0;
  width: 70%;
  border: none;
  border-bottom: black 1px solid !important;
}
.sendpaper-button {
  display: block;
  background-color: black;
  color: white;
  text-align: center;
  font-size: 1em;
  width: 80%;
  margin: 2% 10%;
  border: none;
  padding: 2%;
}
</style>



// WEBPACK FOOTER //
// src/components/sendNewspaper.vue